

































import DocumentDownloader from "@/components/DocumentDownloader.vue";

export default {
  name: "DocumentsTable",
  components: { DocumentDownloader },
  props: {
    documents: {
      type: Array,
      required: true
    }
  },
  methods: {
    getFileIcon(extension) {
      switch (extension) {
        case ".pdf":
          return "file-pdf";
        case ".doc":
        case ".docx":
          return "file-word";
        case ".csv":
        case ".xls":
        case ".xlsx":
          return "file-excel";
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".gif":
        case ".bmp":
          return "file-image";
        default:
          return "file";
      }
    },
    getFileTitle(extension) {
      switch (extension) {
        case ".pdf":
          return "Pdf";
        case ".doc":
        case ".docx":
          return "Word";
        case ".csv":
        case ".xls":
        case ".xlsx":
          return "Excel";
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".gif":
        case ".bmp":
          return "Image";
        default:
          return "Bestand";
      }
    }
  }
};
